<template>
  <b-container fluid class="px-2">
      <b-container fluid class="text-center pt-3 d-flex mb-3 p-0">
        <h5 class="">
          {{ this.$t("sidebar.titles.equipment") }}
        </h5>

        <b-btn 
            v-if="isDroneProject && tilePersistStatus == 'completed'" 
            class="border-white ml-auto btn-sm"
            :variant="autoIdentifyButtonVariant"
            @click.prevent="openSidebar('auto-identify')">
          <font-awesome-icon v-if="hasCompletedAnalysis" :icon="['fas', 'check-circle']" class="mr-1" />
          {{ autoIdentifyButtonText }}
        </b-btn>
      </b-container>

      <b-container>
        <b-row class="mb-3">
          <b-form-input
            placeholder="Search..."
            v-model="searchQuery"
            @input="filteredEquipments"
          />
        </b-row>
      </b-container>


      <b-row
        v-for="(equipment, index) in favouriteEquipments" 
        v-bind:key="equipment.id"  
      >
        <b-col>
          <b-media class="mb-3" style="align-items: center; cursor:pointer;">
          <template #aside>
            <b-img class="equipment-icon" :src="equipmentIcon(equipment.name)" @click="setMode('equipment', equipment.id)"/>
          </template>
          <div class="d-flex"> 
            <div class="w-75" @click="setMode('equipment', equipment.id)">
              {{ $t(`equipment_type.${equipment.name}`) }}
            </div>

            <div class="ml-auto" >
              <a href="javascript://" class="text-warning" @click.prevent="updateEquipmentConfig(equipment.id, false)">
                <font-awesome-icon :icon="['fas', 'star']" />
              </a>
            </div>
          </div>
        </b-media>
        </b-col>
        
      </b-row>
      
      <hr />

      <b-row
        v-for="(equipment, index) in nonFavouriteEquipments" 
        v-bind:key="equipment.id" 
      >
        <b-col>
          <b-media class="mb-3" style="align-items: center; cursor:pointer;">
          <template #aside>
            <b-img class="equipment-icon" :src="equipmentIcon(equipment.name)" @click="setMode('equipment', equipment.id)"/>
          </template>
          <div class="d-flex"> 
            <div class="w-75" @click="setMode('equipment', equipment.id)">
              {{ $t(`equipment_type.${equipment.name}`) }}
            </div>

            <div class="ml-auto">
              <a href="javascript://" class="text-secondary" @click.prevent="updateEquipmentConfig(equipment.id, true)">
                <font-awesome-icon :icon="['fas', 'star']" />
              </a>
            </div>
          </div>
        </b-media>
        </b-col>
        
      </b-row>
  </b-container>
</template>

<script>
  import { ProjectMixin } from '@/mixins';
  import { mapGetters } from 'vuex';
  export default {
      name: "SelectEquipmentDrawer",
      mixins:[ProjectMixin],

      data(){
        return {
          searchQuery: ""
        };
      },

      computed: {
        ...mapGetters({
          equipments: "equipments/items",
          currentEquipmentConfig: "sections/currentEquipmentConfig",
          projectAnalysis: "projectAnalysis/items",
        }),

        filteredResults() {
          return this.filteredEquipments();
        },

        roofSections: function(){
          return this.sections.filter(s => s.section_type == 'roof')
        },

        equipmentSections: function(){
          return this.sections.filter(s => s.section_type == 'equipment')
        },

        favouriteEquipments: function(){
          return this.filteredResults.filter(e => e.is_favourite == true)
        },

        nonFavouriteEquipments: function(){
          return this.filteredResults.filter(e => e.is_favourite != true)
        },

        tilePersistStatus(){
          if(this.orthoAssetDetail){
            return (this.orthoAssetDetail.metadata || {}).tile_persist_status
          }
        },

        hasCompletedAnalysis(){
          return this.projectAnalysis.some(pa => pa.status === 'completed')
        },
        
        hasInProgressAnalysis(){
          return this.projectAnalysis.some(pa => pa.status === 'in_progress' || pa.status === 'in_queue')
        },
        
        autoIdentifyButtonVariant(){
          if(this.hasCompletedAnalysis){
            return 'success'
          } else if(this.hasInProgressAnalysis){
            return 'warning'
          } else {
            return 'dark'
          }
        },
        
        autoIdentifyButtonText(){
          if(this.hasCompletedAnalysis){
            return 'Auto identify ✓'
          } else if(this.hasInProgressAnalysis){
            return 'Analyzing...'
          } else {
            return 'Auto identify'
          }
        }
      },

      methods: {
        equipmentIcon(name){
          return require(`@/assets/svg-equipment-icons/${name}.svg`);
        },

        updateEquipmentConfig(id, isFavourite){
          const payload = {
            equipment_config: {
              is_favourite: isFavourite
            }
          }
          this.$store.dispatch('equipments/update',{ id, payload }).then(res=>{
                }).catch(err=>{
                    alert(err)
                }).finally(()=>{
                    this.loading= false
                })
        },

        filteredEquipments(){
          const searchQuery = this.searchQuery.toLowerCase();
          if (searchQuery.length > 0) {
            return this.equipments.filter(equipment => {
              const equipmentName = this.$t(`equipment_type.${equipment.name}`).toLowerCase();
              return equipmentName.includes(searchQuery);
            });
          } else {
            return this.equipments;
          }
        }
      }
  }
</script>
